import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import { formatDate, formatTime } from "../../../constants/helper";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { Loader } from "../../../components";
import { Colors } from "../../../constants/styles";
import {
  Box,
  Typography,
  TextField,
  ButtonGroup,
  Button,
  Divider,
  Autocomplete,
} from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useDownloadExcel } from "react-export-table-to-excel";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import { Col, Row, Form } from "react-bootstrap";

const LapGradeAr = () => {
  const tableRef = useRef(null);
  const { user, setting, dispatch } = useContext(AuthContext);
  let date = new Date();
  let [inputPerTgl, setInputPerTgl] = useState(date);
  let [inputTransTgl, setInputTransTgl] = useState(date);
  const [cabangInput, setCabangInput] = useState("");
  const [lapGradeArRekapData, setLapGradeArRekapData] = useState([]);
  const [lapGradeArData, setLapGradeArData] = useState([]);

  const [allCabang, setAllCabang] = useState([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [persenLoading, setPersenLoading] = useState("0");
  const { screenSize } = useStateContext();
  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  const cabangOptions = allCabang.map((user) => ({
    label: `${user._id} - ${user.namaCabang}`,
  }));

  useEffect(() => {
    if (user.tipeUser === "MGR") {
      getAllCabang();
    } else {
      setCabangInput(user.cabang._id);
    }
  }, []);

  const getAllCabang = async () => {
    setLoading(true);
    const allCabang = await axios.post(`${tempUrl}/cabangs`, {
      id: user._id,
      token: user.token,
    });
    setAllCabang(allCabang.data);
    setLoading(false);
  };

  const getLapGradeAr = async () => {
    setLoading(true);
    const response = await axios.post(`${tempUrl}/lapGradeAr`, {
      perTgl: inputPerTgl,
      transTgl: inputTransTgl,
      id: user._id,
      token: user.token,
      kodeCabang: user.cabang._id,
    });
    setLapGradeArData(response.data);
    setLapGradeArRekapData([]);
    setLoading(false);
  };

  const getLapGradeArRekap = async () => {
    setLoading(true);
    const response = await axios.post(`${tempUrl}/lapGradeArRekap`, {
      perTgl: inputPerTgl,
      transTgl: inputTransTgl,
      id: user._id,
      token: user.token,
      kodeCabang: user.cabang._id,
    });
    setLapGradeArRekapData(response.data);
    setLapGradeArData([]);
    setLoading(false);
  };

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Grade AR",
    sheet: "LapGradeAr",
  });

  if (loading) {
    return <Loader persenLoading={persenLoading} />;
  }

  return (
    <Box>
      <Typography color="#757575">Laporan</Typography>
      <Typography variant="h4" sx={subTitleText}>
        Laporan Grade AR
      </Typography>
      <Divider sx={dividerStyle} />
      <Box sx={showDataWrapper}>
        <Row>
          <Col sm={6}>
            <Form.Group
              as={Row}
              className="mb-3"
              controlId="formPlaintextPassword"
            >
              <Form.Label column sm="4" style={textRight}>
                Cabang :
              </Form.Label>
              {user.tipeUser === "MGR" ? (
                <Col sm="8">
                  <Autocomplete
                    size="small"
                    disablePortal
                    id="combo-box-demo"
                    options={cabangOptions}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        error={error && cabangInput.length === 0 && true}
                        helperText={
                          error &&
                          cabangInput.length === 0 &&
                          "Cabang harus diisi!"
                        }
                        placeholder="SEMUA CABANG"
                        {...params}
                      />
                    )}
                    onInputChange={(e, value) => {
                      setCabangInput(value.split(" ", 1)[0]);
                    }}
                    value={cabangInput}
                  />
                </Col>
              ) : (
                <Col sm="8">
                  <Form.Control value={cabangInput} disabled />
                </Col>
              )}
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Form.Group
              as={Row}
              className="mb-3"
              controlId="formPlaintextPassword"
            >
              <Form.Label column sm="4" style={textRight}>
                Per Tgl. :
              </Form.Label>
              <Col sm="8">
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selected={inputPerTgl}
                  onChange={(e) => setInputPerTgl(e)}
                  customInput={
                    <TextField
                      error={error && inputPerTgl === null && true}
                      helperText={
                        error && inputPerTgl === null && "Per Tgl. harus diisi!"
                      }
                      sx={{ width: "100%" }}
                      size="small"
                    />
                  }
                />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Form.Group
              as={Row}
              className="mb-3"
              controlId="formPlaintextPassword"
            >
              <Form.Label column sm="4" style={textRight}>
                Per Tgl. Trans :
              </Form.Label>
              <Col sm="8">
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selected={inputTransTgl}
                  onChange={(e) => setInputTransTgl(e)}
                  customInput={
                    <TextField
                      error={error && inputTransTgl === null && true}
                      helperText={
                        error &&
                        inputTransTgl === null &&
                        "Per Tgl. Trans harus diisi!"
                      }
                      sx={{ width: "100%" }}
                      size="small"
                    />
                  }
                />
              </Col>
            </Form.Group>
          </Col>
        </Row>
      </Box>
      <Box sx={spacingTop}>
        <ButtonGroup variant="outlined" color="secondary">
          <Button
            variant="contained"
            startIcon={<DownloadIcon />}
            onClick={() => {
              getLapGradeArRekap();
            }}
          >
            REKAP
          </Button>
          <Button
            startIcon={<DownloadIcon />}
            onClick={() => {
              getLapGradeAr();
            }}
          >
            DETAIL
          </Button>
        </ButtonGroup>
      </Box>
      {lapGradeArData.length > 0 && (
        <>
          <Button
            variant="outlined"
            color="secondary"
            startIcon={<DownloadIcon />}
            sx={{ marginTop: "10px" }}
            onClick={onDownload}
          >
            EXCEL
          </Button>
        </>
      )}
      <table
        ref={tableRef}
        style={{ visibility: lapGradeArData.length > 0 ? "visible" : "hidden" }}
      >
        <tbody>
          <tr>
            <th>kategori</th>
            <th>kontrak</th>
            <th>nama</th>
            <th>alamat</th>
            <th>tanggal</th>
            <th>angsuran</th>
            <th>bulan</th>
            <th>sisa</th>
            <th>j_tempo</th>
          </tr>
          {lapGradeArData.map((item, i) => (
            <tr>
              <th>{item.kategori}</th>
              <th>{item.kontrak}</th>
              <th>{item.nama}</th>
              <th>{item.alamat}</th>
              <th>{item.tanggal}</th>
              <th>{item.angsuran}</th>
              <th>{item.bulan}</th>
              <th>{item.sisa}</th>
              <th>{item.j_tempo}</th>
            </tr>
          ))}
        </tbody>
      </table>
      {lapGradeArRekapData.length > 0 && (
        <>
          <Button
            variant="outlined"
            color="secondary"
            startIcon={<DownloadIcon />}
            sx={{ marginTop: "10px" }}
            onClick={onDownload}
          >
            EXCEL
          </Button>
        </>
      )}
      <table
        ref={tableRef}
        style={{
          visibility: lapGradeArRekapData.length > 0 ? "visible" : "hidden",
        }}
      >
        <tbody>
          <tr>
            <th>Kode</th>
            <th>Keterangan</th>
            <th>Jumlah</th>
          </tr>
          {lapGradeArRekapData.map((item, i) => (
            <tr>
              <th>{item.kode}</th>
              <th>{item.keterangan}</th>
              <th>{item.jumlah}</th>
            </tr>
          ))}
        </tbody>
      </table>
    </Box>
  );
};

export default LapGradeAr;

const subTitleText = {
  fontWeight: "900",
};

const dividerStyle = {
  mt: 2,
};

const spacingTop = {
  mt: 4,
};

const labelInput = {
  fontWeight: "600",
  marginLeft: 1,
};

const showDataWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  // maxWidth: {
  //   md: "40vw"
  // }
};
